import createReactComponent from '../createReactComponent';
export default createReactComponent('logic-and', 'IconLogicAnd', [
  ['path', { d: 'M22 12h-5', key: 'svg-0' }],
  ['path', { d: 'M2 9h5', key: 'svg-1' }],
  ['path', { d: 'M2 15h5', key: 'svg-2' }],
  ['path', { d: 'M9 5c6 0 8 3.5 8 7s-2 7 -8 7h-2v-14h2z', key: 'svg-3' }],
]);
